import { render, staticRenderFns } from "./upgrade-now-lite.vue?vue&type=template&id=716c244c&scoped=true"
import script from "./upgrade-now-lite.vue?vue&type=script&lang=js"
export * from "./upgrade-now-lite.vue?vue&type=script&lang=js"
import style0 from "./upgrade-now-lite.vue?vue&type=style&index=0&id=716c244c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716c244c",
  null
  
)

export default component.exports